import { openBlock as e, createElementBlock as l, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ t("path", {
  fill: "#496E2D",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), s = /* @__PURE__ */ t("path", {
  fill: "#FFDA44",
  d: "M20 23.105a6.958 6.958 0 0 1-6.795-5.465 6.956 6.956 0 1 0 13.59 0A6.958 6.958 0 0 1 20 23.105Z"
}, null, -1), c = /* @__PURE__ */ t("path", {
  fill: "#FFDA44",
  d: "m20 13.913.648 1.993h2.095l-1.695 1.231.647 1.993L20 17.9l-1.695 1.231.647-1.992-1.695-1.232h2.095L20 13.913Z"
}, null, -1), i = [
  n,
  s,
  c
];
function r(a, d) {
  return e(), l("svg", o, [...i]);
}
const _ = { render: r };
export {
  _ as default,
  r as render
};
